import styles from './DescriptionDetails.module.css'

const DescriptionDetails = ({ children }): JSX.Element => {
	return <dd className={styles.descriptionDetails}>{children}</dd>
}

export default DescriptionDetails
